module.exports = __webpack_public_path__ + "img/wj_tb_wj.ec7652ac.png";